(function() {
    angular
        .module('sodDocumentLibrary')
        .factory('DocumentService', DocumentService);

    function DocumentService(GenericModel, lodash) {
        return function(options) {
            return {
                query: query,
                remove: remove
            };

            function query(dsData, searchText, folderId) {
                let datasource = options.datasources.query.url;
                let method = lodash.get(options.datasources.query, 'method', 'query');
                const _dsData = angular.merge(
                    {},
                    dsData,
                    lodash.get(options.datasources.query, 'params' , {})
                );

                var appliedFilters = [];

                if (!!searchText) {
                    appliedFilters.push({
                        field: 'filter_search_text',
                        operator: 'contains',
                        value: searchText.toString()
                    });
                }

                var myOptions = {
                    filter:  appliedFilters,
                };

                if (myOptions.filter.length > 0) {
                    method = 'search';
                    datasource = datasource+"/filter";
                }

                var data = generateResourceOption(_dsData, myOptions, method);

                var model = new GenericModel(datasource);
                if (['query', 'get', 'getArray'].indexOf(method) >= 0) {
                    if (!!folderId) {
                        data.folderId = folderId;
                    }
                    return model[method](data).$promise;
                } else {
                    const p = {};
                    if (!!folderId) {
                        p.folderId = folderId;
                    }
                    return model[method](p, data).$promise;
                }
            }

            function remove(id) {
                const method = lodash.get(options.datasources.remove, 'method', 'delete');
                let url = options.datasources.remove.url;
                url = decodeURI(url).replace(new RegExp('<id>', 'g'), id);
                const model = new GenericModel(url);
                return model[method]().$promise;
            }
        };

        function generateResourceOption(resourceData, myData, method) {
            var params = {};
            params = angular.merge(params, resourceData, myData);
            if (method == 'search') {
                params = {'data': params};
            }
            return params;
        }
    }
})();